import React from 'react';
import dynamic from 'next/dynamic';

import { isProd } from 'src/environment';
import { useCurator } from 'src/hooks/useCurator';
import type { ContentPageProps } from 'src/types/PageProps';

const Curator = dynamic(
  () =>
    import('@noths/curator-web').then(async (m) => {
      m.configureCurator({
        baseUrl: isProd()
          ? 'https://gift-finder-service.notonthehighstreet.com'
          : 'https://gift-finder-service.public.shared.qa.noths.com',
        streamUrl: isProd()
          ? 'wss://gift-finder-service-stream.notonthehighstreet.com'
          : 'wss://gift-finder-service-stream.public.shared.qa.noths.com',
      });
      return m.Curator;
    }),
  { ssr: false },
);

interface CuratorWrapperProps {
  siteChromeContent?: ContentPageProps['siteChromeContent'];
}

// should match curator-web Product type
interface Product {
  id: string;
  imageUrl: string;
  isSelected?: boolean;
  name: string;
  price: string;
  uri: string;
}

export const CuratorWrapper = ({ siteChromeContent }: CuratorWrapperProps) => {
  const showCurator = siteChromeContent?.enableCurator ?? false;
  const { handleToggle, isCuratorOpen } = useCurator();

  if (!showCurator) {
    return null;
  }

  /**
   * The host will be the production domain
   * @param product - The product to redirect to
   */
  const redirectToPDP = (product: Product) => {
    window.location.href = product.uri;
  };

  return <Curator isOpen={isCuratorOpen} onToggle={handleToggle} productClick={redirectToPDP} />;
};
